import { Typography as AntDTypography } from "antd";
import React, { CSSProperties } from "react";

const { Title, Text, Link, Paragraph } = AntDTypography;

export type TypographyVariant = "title" | "text" | "link" | "paragraph";
type TypographyProps = {
  /** The variant of Typography */
  variant: TypographyVariant;
  /** Content to display */
  children: React.ReactNode;
  /** Optional level for titles (1-5) */
  level?: 1 | 2 | 3 | 4 | 5;
  /** Whether the text is disabled */
  disabled?: boolean;
  /** Whether the text is italic */
  italic?: boolean;
  /** Whether the text is strong (bold) */
  strong?: boolean;
  /** Hyperlink URL for Link variant */
  href?: string;
  color?: string;
  style?: CSSProperties;
};
const Typography: React.FC<TypographyProps> = ({
  variant,
  level = 1,
  children,
  disabled,
  italic,
  strong,
  href,
  color,
  style,
}) => {
  switch (variant) {
    case "title":
      return (
        <Title style={{ color: color, ...style }} level={level}>
          {children}
        </Title>
      );
    case "text":
      return (
        <Text
          style={{ color: color, ...style }}
          disabled={disabled}
          italic={italic}
          strong={strong}
        >
          {children}
        </Text>
      );
    case "link":
      return (
        <Link
          style={{ color: color, ...style }}
          href={href}
          disabled={disabled}
        >
          {children}
        </Link>
      );
    case "paragraph":
      return (
        <Paragraph
          style={{ color: color, ...style }}
          disabled={disabled}
          italic={italic}
          strong={strong}
        >
          {children}
        </Paragraph>
      );
    default:
      return null;
  }
};
export default Typography;
